import { render } from "./SiteHeader.vue?vue&type=template&id=300029d0&scoped=true"
const script = {}

import "./SiteHeader.vue?vue&type=style&index=0&id=300029d0&scoped=true&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-300029d0"]])

export default __exports__